<script setup>
import {
  BellRing, CalendarCheck2, CircleAlert, CircleCheck, ClipboardCheck, Info,
  ListTodo, MessageCircle, ShieldAlert, Thermometer, Video, X
} from '@lucide/vue';
import { useRouter } from 'vue-router';
import { useUiStore } from '../stores/ui.js';

const ui = useUiStore();
const router = useRouter();
const icons = { success: CircleCheck, error: CircleAlert, info: Info };
const notificationIcons = {
  message: MessageCircle,
  task: ListTodo,
  schedule: CalendarCheck2,
  schedule_published: CalendarCheck2,
  temperature: Thermometer,
  audit: Video,
  inventory: ClipboardCheck,
  security: ShieldAlert,
  test: BellRing
};

function toastIcon(item) {
  return item.kind === 'notification'
    ? notificationIcons[item.notificationType] || BellRing
    : icons[item.kind] || Info;
}

function openToast(item) {
  if (!item.url) return;
  ui.dismiss(item.id);
  router.push(item.url);
}
</script>

<template>
  <div class="toast-host" aria-live="polite">
    <TransitionGroup name="toast">
      <div
        v-for="item in ui.toasts"
        :key="item.id"
        class="toast-item"
        :class="{ clickable: item.url }"
        :data-kind="item.kind"
        :data-notification-type="item.notificationType"
        :role="item.url ? 'link' : 'status'"
        :tabindex="item.url ? 0 : undefined"
        @click="openToast(item)"
        @keydown.enter="openToast(item)"
      >
        <span class="toast-icon"><component :is="toastIcon(item)" :size="18" /></span>
        <span class="toast-copy"><strong v-if="item.title">{{ item.title }}</strong><span>{{ item.message }}</span><small v-if="item.url">Нажмите, чтобы открыть</small></span>
        <button class="icon-button subtle" title="Закрыть" aria-label="Закрыть" @click.stop="ui.dismiss(item.id)">
          <X :size="16" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>
